import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import LoadingLayout from '@/layouts/LoadingLayout';

import slackAskBotService from '../../SlackChatBotConnection/SlackConnection/service';

export type AskSlackResponse = {
  success: boolean;
};

const AskSlackRedirect = () => {
  const [, setRedirect] = useCrossWindowState<AskSlackResponse | null>(
    'ask-slack-redirect',
    null,
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && state) {
      const workspaceAlias = state;
      const asyncUpdateHandler = async () => {
        const data = await slackAskBotService.createSlackAskBotInfo(
          code,
          workspaceAlias,
        );

        if (data) {
          setRedirect({ success: true });
          window.close();
        } else {
          navigate('/500', { replace: true });
        }
      };
      asyncUpdateHandler();
    }
  }, [setRedirect, navigate, searchParams]);

  return <LoadingLayout>Connecting this slack channel...</LoadingLayout>;
};

export default AskSlackRedirect;
